<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ChatEmptyState',
  props: {
    username: {
      type: String,
      default: ''
    }
  }
});
</script>

<template>
    <div class="flex flex-col items-start gap-2 h-full">
        <div class="flex flex-col items-start">
            <span class="bg-gradient-to-r from-indigo-600 to-rose-400 inline-block w-fit text-transparent bg-clip-text text-xl/[24px] font-bold">Olá, {{ username }}</span>
            <span class="text-xl/[24px] font-normal text-neutral-600">Como posso ajudar?</span>
        </div>
        <div class="">
            <p class="text-xs/[16px] text-neutral-500 font-medium text-left">Posso responder a qualquer dúvida sobre a sua empresa. É só perguntar! 😉</p> 
        </div>
    </div>
</template>